export function initEventsListPagination() {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.flex-events--list').forEach((block) => {
            const pager = block.querySelector('.js-events-pager');
            if (!pager) return;

            const items = Array.from(block.querySelectorAll('.flex-events__item'));
            const pageButtons = Array.from(pager.querySelectorAll('.js-events-page-btn'));
            const prevBtn = pager.querySelector('.js-events-page-prev');
            const nextBtn = pager.querySelector('.js-events-page-next');
            const totalPages = pageButtons.length;

            let currentPage = 1;

            const showPage = (page) => {
                currentPage = Math.min(Math.max(page, 1), totalPages);

                items.forEach((item) => {
                    item.hidden = Number(item.dataset.page) !== currentPage;
                });

                pageButtons.forEach((btn) => {
                    const isActive = Number(btn.dataset.page) === currentPage;
                    btn.classList.toggle('is-active', isActive);
                    btn.setAttribute('aria-current', isActive ? 'page' : 'false');
                });

                if (prevBtn) prevBtn.disabled = currentPage === 1;
                if (nextBtn) nextBtn.disabled = currentPage === totalPages;
            };

            pager.addEventListener('click', (e) => {
                const btn = e.target.closest('button');
                if (!btn) return;

                if (btn === prevBtn) {
                    showPage(currentPage - 1);
                } else if (btn === nextBtn) {
                    showPage(currentPage + 1);
                } else if (btn.dataset.page) {
                    showPage(Number(btn.dataset.page));
                } else {
                    return;
                }

                block.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });

            showPage(1);
        });
    });
}
